// 获取弹窗容器和关闭按钮
const popupContainer = document.getElementById('popup-container');
const popupClose = document.getElementById('popups-close');

// 打开弹窗
function openPopup() {
  popupContainer.style.display = 'block';
}

// 关闭弹窗
function closePopup() {
  popupContainer.style.display = 'none';
}

// 点击关闭按钮或弹窗外部区域时关闭弹窗
popupClose.addEventListener('click', closePopup);
popupContainer.addEventListener('click', function(e) {
  if (e.target === popupContainer) {
    closePopup();
  }
});
